import React from 'react';
import { Placeholder, Carousel } from '@thd-olt-component-react/core-ui';

export const ProductsPlaceholder = () => {
  return (
    <Carousel>
      {
        new Array(7).fill('').map((productValue, productKey) => (
          <Placeholder type="rect" width="216px" height="443px" key={productKey} />
        ))
      }
    </Carousel>
  );
};